module.exports = __webpack_public_path__ + "static/media/Old_Homestead_bylaws.6facfafc.pdf";